import axios from 'axios'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { useLocation, useNavigate} from 'react-router'
import { Link } from 'react-router-dom'
import { SERVER_URL } from '../config'
import actionCart from '../utils/actionCart'
import styles from "./css/ItemPage.module.css"

export const ItemPage = ({ isAdmin }) => {
  const location = useLocation()
  const id = +location.pathname.split("/")[2]

  const [item, setItem] = useState({})
  const [brand, setBrand] = useState("")
  const [type, setType] = useState("")

  const [isAuth, setIsAuth] = useState(false)
  const [itemInBasket, setItemInBasket] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    if (localStorage.getItem("user-token")) {
      setIsAuth(true)
    }

    loadItem()
    if (location.pathname === "/basket") {
      setItemInBasket(true)
    }

  }, [])

  const loadItem = async () => {
    const response = await axios.get(SERVER_URL + "/api/item/" + id)
    setItem(response.data)

    try {
      const { data: itemInfo } = await axios.get(SERVER_URL + `/api/item/itemInfo?itemId=${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("user-token")
        }
      })
      setItemInBasket(itemInfo.itemInBasket)
      setBrand(itemInfo.brand)
      setType(itemInfo.type)
    } catch (e) {
      console.log(e)
    }
  }

  const addToCart = async item => await actionCart("add", item).then(() => setItemInBasket(true))
  const removeFromCart = async item => await actionCart("remove", item).then(() => setItemInBasket(false))

  const deleteItem = async () => {
    try {
      await axios.delete(SERVER_URL + "/api/item/" + item.id, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("user-token")
        }
      })
      alert("Ви видалили цей товар")
      navigate(-1)
    } catch (e) {
      console.log(e.response.data)
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.main}>
        <div className={styles.image}
          style={{ background: `url(${item.img}) 50% 50%/cover` }}
        >
        </div>
        <div style={{ width: "100%" }} className={styles.text}>
          <h2 className={styles.h2}>{item.name}</h2>
          <p className={styles.categories}>
            <Link to={`/brand/${item.brandId}`}>{brand}</Link>
            <Link to={`/type/${item.typeId}`}>{type}</Link>
          </p>
          <p className={styles.id}>Ідентифікатор: {item.id}</p>
          <div className={styles.buy}>
            {
              isAuth
                ? itemInBasket
                  ? <button onClick={() => removeFromCart(item)} className="add add_big">- Вилучити з кошика</button>
                  : <button onClick={() => addToCart(item)} className="add add_big">+ Додати в кошик</button>
                : <button onClick={() => navigate("/login")} className="add add_big">+ Додати в кошик</button>
            }
            <p className={styles.price}>{item.price}₴</p>
          </div>
          {
            isAdmin && <button onClick={() => deleteItem()} style={{ margin: "10px 0 0 0" }} className="add red">Видалити товар</button>
          }
        </div>
      </div>
      <div className={styles.info}>
        {
          item.info !== "[]"
            ?
            <div>
              <h3 className={styles.h3}>Інформація</h3>
              {item.info
                ?
                JSON.parse(item.info).map(item =>
                  <p key={item.field} className={styles.pair}>
                    <span>{item.field}</span>
                    <span>{item.value}</span>
                  </p>
                )
                : <></>
              }
            </div>
            : <></>
        }
      </div>
    </div>
  )
}
